function normEmail(value) {
  if (!value) {
    return ''
  }
  return String(value).trim().toLowerCase()
}

/**
 * 是否允许在「邮箱账号」体系下做邮箱增删：当前登录身份须与主邮箱一致。
 * 依据 /api/user 的 login_mail_id、login_mail（脱敏），必要时用 username 与主邮箱明文比对。
 */
/** @param {{ mail_id?: string, mail?: string, mail_raw?: string }} primaryMail 主邮箱条目（来自 mailList 中 main:true） */
export function computeIsMainMailLogin(loginInfo, primaryMail) {
  const login = loginInfo || {}
  const mainId =
    primaryMail && primaryMail.mail_id != null
      ? String(primaryMail.mail_id).trim()
      : ''
  const mainMasked =
    primaryMail && primaryMail.mail != null
      ? String(primaryMail.mail).trim()
      : ''
  const mainRaw = normEmail(
    (primaryMail && primaryMail.mail_raw) != null
      ? String(primaryMail.mail_raw)
      : ''
  )

  if (!login.use_mail) {
    return true
  }
  if (!mainId) {
    return true
  }

  const sid =
    login.login_mail_id != null ? String(login.login_mail_id).trim() : ''
  if (sid && String(mainId).trim() === sid) {
    return true
  }

  const lm = login.login_mail != null ? String(login.login_mail).trim() : ''
  const masked = mainMasked ? String(mainMasked).trim() : ''
  if (lm && masked && lm === masked) {
    return true
  }

  const user = normEmail(login.username)
  if (mainRaw) {
    return !!(user && user === mainRaw)
  }

  return false
}
